<template>
  <img
    :class="classes"
    :src="item.Image.File.Url"
    :alt="item.Image.Description"
    :title="item.Image.Description"
    :data-contentful-image="item.Id"
  >
</template>

<script>
export default {
  name: 'ContentfulImage',
  props: {
    item: { type: Object, default: null, required: true },
    classes: { type: Array, default: null }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/shared/components/contentful/ContentfulImage.vue